<template>
  <div>
    <div class="rel_title">{{ relatorio.title }}</div>
    <div class="px-4 pt-4">
      <template v-if="isResultadosIan">
        <v-row>
          <v-col cols="4">
            <v-select
              v-model="filtros.nivel"
              :items="nivelOptions"
              label="Nível"
              clearable
            ></v-select>
          </v-col>
          <v-col cols="4" class="d-flex align-center">
            <v-checkbox
              v-model="filtros.agruparTemas"
              label="Agrupar por Temas"
              hide-details
            ></v-checkbox>
          </v-col>
          <v-col cols="4">
            <v-select
              v-model="filtros.tipoMunicipio"
              :items="tipoMunicipioOptions"
              label="Tipo de Município"
              @change="handleTipoMunicipioChange"
            ></v-select>
          </v-col>
        </v-row>
      </template>
      <template v-if="selectedRelatorioFiltro">
        <v-row>
          <v-col
            cols="4"
            v-if="selectedRelatorioFiltro.includes(filtrosEnum.municipio)"
          >
            <template v-if="isResultadosIan">
              <v-autocomplete
                v-model="filtros.municipioId"
                :items="resultadosIanMunicipios"
                item-text="nome"
                item-value="municipioId"
                label="Municípios"
                placeholder="Selecione..."
                multiple
                clearable
              ></v-autocomplete>
            </template>
            <template v-else>
              <combobox-municipio
                multiple
                :clearable="true"
                :value="filtros.municipioId"
                :filterByStatusAndProject="municipioFilterByStatus"
                @onChange="(e) => (filtros.municipioId = e)"
              ></combobox-municipio>
            </template>
          </v-col>
          <v-col
            v-if="
              selectedRelatorioFiltro.includes(filtrosEnum.grupoClienteOculto)
            "
          >
            <ComboboxClienteOcultoGrupos
              @onChange="
                (e) =>
                  (filtros.seloClienteOcultoGrupoId = e.map(
                    (item) => item.grupoId
                  ))
              "
            ></ComboboxClienteOcultoGrupos>
          </v-col>
          <v-col
            cols="4"
            v-if="
              selectedRelatorioFiltro.includes(filtrosEnum.responsavel) ||
              selectedRelatorioFiltro.includes(filtrosEnum.usuario)
            "
          >
            <app-consultant-combobox
              :filter="filtros"
              :consultorValue="
                selectedRelatorioFiltro.includes(filtrosEnum.usuario)
                  ? 'Usuário'
                  : 'Responsável'
              "
            ></app-consultant-combobox>
          </v-col>
          <v-col
            cols="3"
            v-if="selectedRelatorioFiltro.includes(filtrosEnum.dataInicial)"
          >
            <datepicker
              :label="relatorioId == 14 ? 'T0' : 'Data Inicial'"
              @onChange="(e) => (filtros.dataInicial = e)"
              :value="filtros.dataInicial"
            >
            </datepicker>
          </v-col>
          <v-col
            cols="3"
            v-if="selectedRelatorioFiltro.includes(filtrosEnum.dataFim)"
          >
            <datepicker
              :label="relatorioId == 14 ? 'T1' : 'Data Final'"
              @onChange="(e) => (filtros.dataFim = e)"
              :value="filtros.dataFim"
            ></datepicker>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="selectedRelatorioFiltro.includes(filtrosEnum.solucao)">
            <app-solution-combobox
              :filter="filtros"
              @changeSolution="(e) => (filtros.solucaoId = e)"
              multiple
            ></app-solution-combobox>
          </v-col>
          <v-col
            v-if="selectedRelatorioFiltro.includes(filtrosEnum.grupoSolucao)"
          >
            <app-group-solution-combobox
              :filter="filtros"
              @changeGroupSolution="(e) => (filtros.grupoSolucaoId = e)"
            ></app-group-solution-combobox>
          </v-col>
          <v-col
            v-if="selectedRelatorioFiltro.includes(filtrosEnum.grupoUsuario)"
          >
            <app-group-combobox
              :filter="filtros"
              :placeholderName="'Grupo de usuário'"
            ></app-group-combobox>
          </v-col>
          <v-col v-if="selectedRelatorioFiltro.includes(filtrosEnum.regional)">
            <combobox :filter="filtros" multiple></combobox>
          </v-col>

          <v-col
            v-if="
              selectedRelatorioFiltro.includes(filtrosEnum.statusRelacionamento)
            "
          >
            <app-status-relacionamento
              :filter="filtros"
              :isMultiple="true"
              :includeElegivelIan="supportsElegivelIanStatus"
            ></app-status-relacionamento>
          </v-col>
          <v-col v-if="selectedRelatorioFiltro.includes(filtrosEnum.projeto)">
            <combobox-projeto
              :filter="filtros"
              @changeProject="(e) => (filtros.projectId = e)"
            ></combobox-projeto>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="selectedRelatorioFiltro.includes(filtrosEnum.uf)">
            <ComboboxUf :filter="filtros"></ComboboxUf>
          </v-col>
          <v-col v-if="selectedRelatorioFiltro.includes(filtrosEnum.eixo)">
            <combobox-eixo
              :filter="filtros"
              :payloadEixos="[]"
              :label="isSala ? 'Pilar' : 'Eixos'"
            ></combobox-eixo>
          </v-col>
          <v-col v-if="selectedRelatorioFiltro.includes(filtrosEnum.tema)">
            <combobox-tema
              @onChange="(e) => (filtros.temaId = e.map((item) => item.temaId))"
            ></combobox-tema>
          </v-col>
          <v-col v-if="selectedRelatorioFiltro.includes(filtrosEnum.selo)">
            <ComboboxSelo :filter="filtros"> </ComboboxSelo>
          </v-col>
          <v-col
            v-if="selectedRelatorioFiltro.includes(filtrosEnum.parcelasStatus)"
          >
            <combobox-parcelas-status
              :value="filtros.parcelasStatusId"
              @change="(value) => (filtros.parcelasStatusId = value)"
            ></combobox-parcelas-status>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-if="selectedRelatorioFiltro.includes(filtrosEnum.recursoGrupoCriterio)"
          >
            <v-autocomplete
              v-model="filtros.gruposCriteriosId"
              :items="resourceDashboardFilters.grupos"
              :loading="resourceFiltersLoading"
              :disabled="resourceFiltersLoading"
              item-text="nome"
              item-value="id"
              label="Grupo de critérios"
              multiple
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col
            v-if="selectedRelatorioFiltro.includes(filtrosEnum.recursoCriterio)"
          >
            <v-autocomplete
              v-model="filtros.criteriosId"
              :items="criteriosOptions"
              :loading="resourceFiltersLoading"
              :disabled="resourceFiltersLoading"
              item-text="label"
              item-value="perguntaId"
              label="Critérios"
              multiple
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col
            v-if="selectedRelatorioFiltro.includes(filtrosEnum.recursoStatus)"
          >
            <v-autocomplete
              v-model="filtros.recursosStatus"
              :items="resourceStatusOptions"
              item-text="text"
              item-value="value"
              label="Status do recurso"
              multiple
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col
            v-if="selectedRelatorioFiltro.includes(filtrosEnum.criterioPergunta)"
          >
            <combobox-pergunta
              :value="filtros.perguntasId"
              @change="(value) => (filtros.perguntasId = value)"
            ></combobox-pergunta>
          </v-col>
        </v-row>
      </template>
      <v-row class="justify-end px-4">
        <v-btn color="success" class="buttonc" @click="$emit('gerarXlsx')">
          <v-icon dark>mdi-download</v-icon
          >{{ relatorioId == 14 ? "Gerar PDF" : "Gerar XLS" }}
        </v-btn>
        <template v-if="selectedRelatorioFiltro.length">
          <v-btn color="primary" @click="filtrar">{{
            relatorioId == 14 ? "Gerar Relatório" : "Filtrar"
          }}</v-btn>
        </template>
      </v-row>
    </div>
  </div>
</template>
<script>
import ComboboxMunicipio from "@/modules/city/components/ComboboxMunicipio.vue";
import { AppConsultantCombobox } from "@/modules/user";
import Datepicker from "@/components/datepicker/datepicker.vue";
import { AppGroupSolutionCombobox } from "@/modules/group-solution";
import { AppSolutionCombobox } from "@/modules/solution";
import AppGroupCombobox from "@/modules/user/components/group/Combobox";
import AppStatusRelacionamento from "@/modules/city/components/ComboboxStatusRelacionamento";
import { administrativeDashboardAPI } from "@/modules/administrative-dashboard";
import { filtros } from "../../utils/filtros";
import Combobox from "@/modules/ur/components/Combobox";
import ComboboxUf from "@/modules/uf/components/Combobox";
import ComboboxEixo from "@/modules/eixo/components/Autocomplete";
import ComboboxTema from "@/modules/tema/components/TemaCombobox";
import ComboboxProjeto from "@/modules/project/components/Combobox";
import ComboboxClienteOcultoGrupos from "@/modules/clienteOculto/components/ComboboxClienteOcultoGrupos";
import ComboboxParcelasStatus from "@/modules/administrative-dashboard/Combobox/ComboboxParcelasStatus.vue";
import ComboboxPergunta from "@/modules/administrative-dashboard/Combobox/ComboboxPergunta.vue";

import { mapGetters, mapActions } from "vuex";
import ComboboxSelo from "@/modules/selos/components/ComboboxSelo.vue";
import { RESOURCE_STATUSES } from "@/modules/resource/constants";

const RELATORIO_EVIDENCIAS_EMPRESA_ID = 58;
const RELATORIO_RESULTADOS_IAN_ROTAS = [
  "resultados-ian",
  "resultados-ian-detalhado-quesito",
];
const RELATORIO_IAN_STATUS_ROTAS = [
  "ian-consolidado",
  "ian-extrato-detalhado",
];

const INITIAL_FILTER_VALUES = {
  municipioId: [],
  usuarioId: null,
  grupoSolucaoId: null,
  dataInicial: null,
  dataFim: null,
  solucaoId: [],
  statusId: null,
  id_unidade_regional: [],
  uf: [],
  eixosIds: [],
  temaId: [],
  resposta: [],
  projectId: null,
  seloClienteOcultoGrupoId: [],
  selo: [],
  gruposCriteriosId: [],
  criteriosId: [],
  recursosStatus: [],
  parcelasStatusId: [],
  perguntasId: [],
  nivel: "regional",
  agruparTemas: true,
  tipoMunicipio: "ALL",
};

export default {
  components: {
    ComboboxMunicipio,
    AppConsultantCombobox,
    Datepicker,
    AppGroupSolutionCombobox,
    AppSolutionCombobox,
    AppGroupCombobox,
    AppStatusRelacionamento,
    Combobox,
    ComboboxUf,
    ComboboxEixo,
    ComboboxTema,
    ComboboxProjeto,
    ComboboxClienteOcultoGrupos,
    ComboboxSelo,
    ComboboxParcelasStatus,
    ComboboxPergunta,
  },
  props: {
    relatorio: Object,
    regional: Array,
  },
  computed: {
    ...mapGetters(["isSala"]),
    relatorioId() {
      return this.relatorio.id;
    },
    isResultadosIan() {
      return (
        this.relatorio &&
        RELATORIO_RESULTADOS_IAN_ROTAS.includes(this.relatorio.rotaApi)
      );
    },
    supportsElegivelIanStatus() {
      return (
        this.relatorio &&
        RELATORIO_IAN_STATUS_ROTAS.includes(this.relatorio.rotaApi)
      );
    },
    selectedRelatorioFiltro() {
      return this.relatorio.filters;
    },
    defaultRelatorioFiltro() {
      return this.relatorio.defaultFilters;
    },
    municipioFilterByStatus() {
      if (this.relatorioId === RELATORIO_EVIDENCIAS_EMPRESA_ID) {
        return { statusId: [3], projetoId: null };
      }

      return { statusId: [], projetoId: null };
    },
    resourceStatusOptions() {
      return RESOURCE_STATUSES;
    },
    criteriosOptions() {
      if (!this.resourceDashboardFilters.criterios) {
        return [];
      }

      if (
        !this.filtros.gruposCriteriosId ||
        this.filtros.gruposCriteriosId.length === 0
      ) {
        return this.resourceDashboardFilters.criterios;
      }

      return this.resourceDashboardFilters.criterios.filter((criterio) =>
        this.filtros.gruposCriteriosId.includes(criterio.grupoId)
      );
    },
    requiresResourceFilters() {
      const selecionados = this.selectedRelatorioFiltro || [];
      return (
        selecionados.includes(this.filtrosEnum.recursoGrupoCriterio) ||
        selecionados.includes(this.filtrosEnum.recursoCriterio) ||
        selecionados.includes(this.filtrosEnum.recursoStatus)
      );
    },
    nivelOptions() {
      return [
        { text: "UF", value: "uf" },
        { text: "Regional", value: "regional" },
        { text: "Município", value: "municipio" },
      ];
    },
    tipoMunicipioOptions() {
      return [
        { text: "Elegíveis IAN", value: "ONLY_ELIGIBLE" },
        { text: "Não elegíveis IAN", value: "ONLY_NOT_ELIGIBLE" },
        { text: "Todos", value: "ALL" },
      ];
    },
  },
  watch: {
    relatorio: {
      handler(val, oldVal) {
        this.filtros = {
          ...INITIAL_FILTER_VALUES,
          ...this.defaultRelatorioFiltro,
        };
        this.ensureResourceFilters();
        if (this.isResultadosIan) {
          this.loadResultadosIanMunicipios();
        }
      },
      deep: true,
    },
    selectedRelatorioFiltro(val) {
      if (val) {
        this.ensureResourceFilters();
      }
    },
    "filtros.gruposCriteriosId"(val) {
      if (!Array.isArray(this.filtros.criteriosId)) {
        this.filtros.criteriosId = [];
      }

      if (!val || val.length === 0) {
        return;
      }

      this.filtros.criteriosId = this.filtros.criteriosId.filter((id) =>
        this.criteriosOptions.some((criterio) => criterio.perguntaId === id)
      );
    },
  },
  data() {
    return {
      filtros: { ...INITIAL_FILTER_VALUES, ...this.defaultRelatorioFiltro },
      filtrosEnum: filtros,
      resourceDashboardFilters: { grupos: [], criterios: [] },
      resourceFiltersLoading: false,
      resultadosIanMunicipios: [],
    };
  },
  mounted() {
    this.filtros = {
      ...INITIAL_FILTER_VALUES,
      ...this.defaultRelatorioFiltro,
    };
    this.ensureResourceFilters();
    if (this.isResultadosIan) {
      this.loadResultadosIanMunicipios();
    }
  },

  methods: {
    ...mapActions(["setLoading"]),
    ensureResourceFilters() {
      if (!this.requiresResourceFilters) {
        return;
      }

      if (
        this.resourceDashboardFilters.grupos.length === 0 &&
        !this.resourceFiltersLoading
      ) {
        this.loadResourceFilters();
      }
    },
    loadResourceFilters() {
      this.resourceFiltersLoading = true;
      administrativeDashboardAPI
        .getResourceDashboardFilters()
        .then(({ data }) => {
          const grupos = data?.grupos || [];
          const criterios = (data?.criterios || []).map((item) => ({
            ...item,
            label: item.numero ? `${item.numero} - ${item.titulo}` : item.titulo,
          }));

          this.resourceDashboardFilters = { grupos, criterios };
        })
        .catch(() => {
          this.resourceDashboardFilters = { grupos: [], criterios: [] };
        })
        .finally(() => {
          this.resourceFiltersLoading = false;
        });
    },
    handleTipoMunicipioChange() {
      if (!this.isResultadosIan) return;

      this.filtros.municipioId = [];
      this.loadResultadosIanMunicipios();
    },
    loadResultadosIanMunicipios() {
      this.setLoading(true);
      administrativeDashboardAPI
        .getResultadosIanMunicipios(this.filtros.tipoMunicipio)
        .then(({ data }) => {
          this.resultadosIanMunicipios = data || [];
        })
        .catch(() => {
          this.resultadosIanMunicipios = [];
        })
        .finally(() => {
          this.setLoading(false);
        });
    },
    filtrar() {
      this.$emit("filtrar", this.filtros);
    },
    gerarXlsx() {
      this.setLoading(true);
      administrativeDashboardAPI
        .getDashboardCities(this.filtros)
        .then((resp) => {
          this.cities = resp.data;

          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao buscar dados dos municípios");
        });
    },
  },
};
</script>
<style scoped>
.padding {
  padding: 2rem;
}
.buttonc {
  margin-right: 1rem;
}
.rel_title {
  background: var(--corPrimaria);
  color: #fff;
  padding: 1rem;
  text-align: center;
}
</style>
